import * as React from 'react'

const SvgBlueCapIcon = (props) => (
  <svg
    width="56"
    height="57"
    viewBox="0 0 56 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4413_93593)">
      <rect x="12" y="0.775391" width="32" height="32" rx="8" fill="#444CE7" />
      <path
        d="M23.333 15.4424V19.4499C23.333 19.6892 23.333 19.8088 23.3694 19.9145C23.4017 20.0079 23.4543 20.093 23.5234 20.1635C23.6016 20.2434 23.7086 20.2969 23.9226 20.4039L27.5226 22.2039C27.6976 22.2914 27.785 22.3351 27.8767 22.3523C27.958 22.3675 28.0414 22.3675 28.1226 22.3523C28.2143 22.3351 28.3018 22.2914 28.4767 22.2039L32.0767 20.4039C32.2907 20.2969 32.3978 20.2434 32.476 20.1635C32.5451 20.093 32.5977 20.0079 32.6299 19.9145C32.6663 19.8088 32.6663 19.6892 32.6663 19.4499V15.4424M21.333 14.4424L27.7612 11.2283C27.8486 11.1846 27.8923 11.1628 27.9382 11.1542C27.9788 11.1465 28.0205 11.1465 28.0611 11.1542C28.107 11.1628 28.1507 11.1846 28.2382 11.2283L34.6663 14.4424L28.2382 17.6565C28.1507 17.7002 28.107 17.7221 28.0611 17.7307C28.0205 17.7383 27.9788 17.7383 27.9382 17.7307C27.8923 17.7221 27.8486 17.7002 27.7612 17.6565L21.333 14.4424Z"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4413_93593"
        x="0"
        y="0.775391"
        width="56"
        height="56"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="12"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_4413_93593"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.266667 0 0 0 0 0.298039 0 0 0 0 0.905882 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4413_93593"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4413_93593"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default SvgBlueCapIcon
